const homePageTranslations = {
  welcomeCard: {
    title: "لنُجعل هذا اليوم الأفضل لك حتى الآن!",
    action: "ابدأ الآن",
  },
  subscriptionCard: {
    title: "الاشتراك ينتهي في",
    action: "ترقية الخطة",
  },
  fillFormCard: {
    subtitle: "برنامجك الجديد بانتظارك.",
    title: "يرجى ملء النموذج.",
    action: "ملء النموذج",
  },
  startingPoint: {
    title: "اختر نقطة البداية.",
    nutritionCard: {
      title: "خطة التغذية",
      action: "عرض البرنامج",
    },
    workoutCard: {
      title: "خطة التمارين",
      action: "عرض البرنامج",
    },
    customerSupport: {
      title: "خدمة العملاء",
      action: "تواصل مع الدعم",
    },
  },
};

export default homePageTranslations;
